import { atom } from "jotai/index";

export const tokensAtom = atom({
  UNIM: 0,
  RBW: 0,
  WETH: 0,
  MATIC: 0,
  CU: 0
});
